import React, { useMemo } from "react";
import { t } from "i18next";
import { SVGICONS } from "config";
import { CHECKED, UNCHECKED, PlusSquare, MinusSquare } from "icons";
import { useLang } from "hooks";
import { UTILS } from "utils";
import C from "Constants";
import { errorNotification } from "utils/Utils";
import { useSelector } from "react-redux";
import OutOfStockModifer from "./OutOfStockModifer";
import { isModifierOutOfStock } from "utils/Utils";
import { PriceRender } from "components/DisplayPrice";

const SingleModifer = ({
  modifer,
  selectedModifierGroups,
  radioButtonClick,
  checkboxClick,
  modifierGroup,
  QuantityChange,
  updateRadioQuantity,
  isStoreSelected,
  isNewUI,
  disable,
  isMaxSelectionReached
}) => {
  const { isSingleSelection , maximumAllowedSelection } = modifierGroup;
  const { currentLang } = useLang();

  const addedQunatity = UTILS.checkedBox(modifer, selectedModifierGroups, modifierGroup) ?? 0
    
  const isSIngleSlectionAllowed =   isSingleSelection || maximumAllowedSelection<=1
    
  const RenderRadioBoxes = ({ modifer }) => {
    return (
      <span key={modifer?._id} className="inline-flex w-6 h-6">
        <span className="w-6 h-6 inline-flex ">
          {addedQunatity ? <SVGICONS.RadioCheck /> : <SVGICONS.RadioUnCheck />}
        </span>
      </span>
    );
  };

  const RenderCheckBoxes = ({ modifer }) => {
    return (
      <span key={modifer?._id} className="inline-flex w-6 h-6">
        <span className="w-6 h-6 inline-flex ">
          {addedQunatity ? <CHECKED /> : <UNCHECKED />}
        </span>
      </span>
    );
  };

  const IncremntCheckBoxQuntity = (addedQunatity=0, modifer, grpId, total) => {
    if (addedQunatity < total) QuantityChange(modifer, grpId, "increment", isNewUI);
    else {
      errorNotification(
        t("is the maximum quantity allowed for", {
          quantity: modifer?.maximumOrderQuantity,
          name: modifer?.baseLanguage?.name,
        }),
        "top-center"
      );
    }
  };

  const IncremntRadioBoxQuntity = (addedQunatity=0, modifer, grpId, total) => {
    if (addedQunatity < total) updateRadioQuantity(modifer, grpId, "increment", isNewUI);
    else
      errorNotification(
        t("is the maximum quantity allowed for", {
          quantity: modifer?.maximumOrderQuantity,
          name: modifer?.baseLanguage?.name,
        }),
        "top-center"
      );
  };
  const { selectedStore } = useSelector((state) => state.store);

  const isModifierOutOFStock = isModifierOutOfStock(modifer, selectedStore);
  if ((isModifierOutOFStock || isStoreSelected === false))
    return (
      <OutOfStockModifer
        {...{
          modifer,
          isSingleSelection,
          isStoreSelected,
          isModifierOutOFStock,
        }}
        isNewUI={isNewUI}
      />
    );

  //todo: remove this after new ui is implemented for delivery and pickup
  const RenderOldUI = () => {
    return (
      <div key={modifer?._id}>
        <span className="inline-flex flex-grow w-full">
          <div className="flex flex-grow  w-full">
            <div
              className="flex-grow flex-shrink inline-flex items-center"
              onClick={
                isSingleSelection === false
                  ? () => checkboxClick(modifer, modifierGroup?._id)
                  : () => radioButtonClick(modifer, modifierGroup?._id)
              }
            >
              <div className="flex flex-1 items-center py-3">
                <div className="flex">
                  {isSingleSelection === false ? (
                    <RenderCheckBoxes {...{ modifer }} />
                  ) : (
                    <RenderRadioBoxes {...{ modifer }} />
                  )}
                </div>
                <div className="flex flex-1 items-center">
                  <div className="flex flex-1 flex-col px-1.5">
                    <p className="text-16x text-outer-space">
                      {modifer?.baseLanguage?.name}
                    </p>
                    <p className="text-13x text-gunsmoke">
                      +
                      {currentLang === C.AR
                        ? modifer?.price?.toFixed(2) + " " + t("AED")
                        : t("AED") + " " + modifer?.price?.toFixed(2)}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center">
              {/* {modifer?.maximumOrderQuantity >= 2 ? ( */}
              <span className="ms-2">
                <div className="inline-flex center relative flex-flex-4">
                  <span
                    className="inline-flex mx-1"
                    onClick={
                      isSingleSelection === false
                        ? () =>
                            QuantityChange(
                              modifer,
                              modifierGroup?._id,
                              "decrement"
                            )
                        : () =>
                            updateRadioQuantity(
                              modifer,
                              modifierGroup?._id,
                              "decrement"
                            )
                    }
                  >
                    <button className="" type="button">
                      <div className="">
                        <span>
                          <MinusSquare />
                        </span>
                      </div>
                    </button>
                  </span>
                  <span className="inline-flex self-center en-font">
                    <span className="text-20x mx-2">
                      {addedQunatity ? addedQunatity : 0}
                    </span>
                  </span>

                  <span
                    className="inline-flex mx-1"
                    onClick={
                      isSingleSelection === false
                        ? () =>
                            IncremntCheckBoxQuntity(
                              addedQunatity,
                              modifer,
                              modifierGroup?._id,
                              modifer?.maximumOrderQuantity
                            )
                        : () =>
                            IncremntRadioBoxQuntity(
                              addedQunatity,
                              modifer,
                              modifierGroup?._id,
                              modifer?.maximumOrderQuantity
                            )
                    }
                  >
                    <button
                      className=""
                      type="button"
                      aria-label="Increase Quantity"
                    >
                      <div className="">
                        <span className="">
                          <PlusSquare />
                        </span>
                      </div>
                    </button>
                  </span>
                </div>
              </span>
              {/* ) : null} */}
            </div>
          </div>
        </span>
      </div>
    );
  };


  const RenderNewUI = () => {
    return (
      <div
        key={modifer?._id}
        className="flex justify-between items-center py-3 border-b border-gray-200"
      >
        {/* Left side: Name + Price */}
        <div
          className="flex items-start flex-col cursor-pointer flex-grow"
          onClick={
            !isSIngleSlectionAllowed
              ? () => checkboxClick(modifer, modifierGroup?._id)
              : () => radioButtonClick(modifer, modifierGroup?._id)
          }
        >
          <p className="text-base font-medium text-gray-900 m-0">
            {modifer?.baseLanguage?.name}
          </p>
         <PriceRender 
         price={modifer?.price ?? 0}
        />
            
          
          {isModifierOutOFStock && (
            <span className="text-13x text-brand-base-primary">
              {t("Out of stock")}
            </span>
          )}
        </div>

        {/* Right side: Checkbox/Radio + Quantity Controls */}
        <div className="flex items-center">
          {/* Show quantity controls if needed */}
          {modifer?.maximumOrderQuantity >= 2 ? (
            <div className="flex items-center justify-end gap-1">
              <button
                type="button"
                onClick={
                  !isSIngleSlectionAllowed
                    ? () =>
                        QuantityChange(modifer, modifierGroup?._id, "decrement" , isNewUI)
                    : () =>
                        updateRadioQuantity(
                          modifer,
                          modifierGroup?._id,
                          "decrement",
                          isNewUI
                        )
                }
                aria-label="Decrease quantity"
                className="p-1"
                disabled={
                  isModifierOutOFStock ||
                  disable ||
                  (!isSIngleSlectionAllowed && !addedQunatity && isMaxSelectionReached)
                }
              >
                <MinusSquare />
              </button>
              <span className="flex-1 text-16x font-medium">{addedQunatity  || 0}</span>
              <button
                type="button"
                disabled={
                  isModifierOutOFStock ||
                  disable ||
                  (!isSIngleSlectionAllowed && isMaxSelectionReached)
                }
                onClick={
                  !isSIngleSlectionAllowed
                    ? () =>
                        IncremntCheckBoxQuntity(
                          addedQunatity,
                          modifer,
                          modifierGroup?._id,
                          modifer?.maximumOrderQuantity
                        )
                    : () =>
                        IncremntRadioBoxQuntity(
                          addedQunatity,
                          modifer,
                          modifierGroup?._id,
                          modifer?.maximumOrderQuantity
                        )
                }
                aria-label="Increase quantity"
                className="p-1"
              >
                <PlusSquare />
              </button>
            </div>
          ) : (
            // The max-selection guard belongs to checkboxes, where a further
            // tick would exceed the allowed count. On a single-select group the
            // maximum is 1, so picking any option disabled every other one and
            // the choice could no longer be changed — only cleared. Choosing a
            // different radio is a replacement, not an addition.
            <button
              disabled={
                isModifierOutOFStock ||
                disable ||
                (!isSIngleSlectionAllowed && !addedQunatity && isMaxSelectionReached)
              }
              onClick={
                isSIngleSlectionAllowed
                  ? () => radioButtonClick(modifer, modifierGroup?._id)
                  : () => checkboxClick(modifer, modifierGroup?._id)
              }
            >
              {isSIngleSlectionAllowed ? (
                <RenderRadioBoxes {...{ modifer }} />
              ) : (
                <RenderCheckBoxes {...{ modifer }} />
              )}
            </button>
          )}
        </div>
      </div>
    );
  };

  return isNewUI ? <RenderNewUI /> : <RenderOldUI />;
};

export default React.memo(SingleModifer);
